export default __webpack_public_path__ + "static/media/rails.6f934520.png";